import { render, staticRenderFns } from "./TaskTableHeader.vue?vue&type=template&id=c5c6c80e&scoped=true"
import script from "./TaskTableHeader.vue?vue&type=script&lang=js"
export * from "./TaskTableHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskTableHeader.scss?vue&type=style&index=0&id=c5c6c80e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c6c80e",
  null
  
)

export default component.exports